<template>
<div>

<ContentHeader :title="$store.state.languages.lang_phrases.otomasyon"  url="CreateFlowCondition" :show_button="true" icon="plus" buttontype="primary" :label="$store.state.languages.lang_phrases.yeni_ekle"></ContentHeader>




<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>



<div class="content_card_content" v-if="!loading">


<template v-if="!items.length">
<div class="flex align-items-center justify-content-center mb-8 mt-8">
<h3 class="text-primary font-medium">Henüz hiç kayıt oluşturulmamış</h3>

</div>
</template>

<template v-else>
<ContentTable :data="items" :columns="columns" routename="FlowCondition"  deleteobjectname="flowcondition" @dataDeleted="getData"  identifier_row_name="condition_id"></ContentTable>
</template>


</div>

</div>
</template>

<script>
export default {

  name: 'FlowConditions',

  data () {
    return {
    	items:[],
    	loading:true,
      columns:[        
      {
        type:"text",
        field:"eventname",        
        with_route:true,
        header:"eylem",
        hide_on_mobile:false,
      },

      {
        type:"pill",
        field:"action",
        header:"aksiyon",
        options:[
          {
            name:"send_mail",
            color:"#352f8d",
            text:"bildirim_gonder",
          },
          {
            name:"attach_to_project",
            color:"#7e2f8d",
            text:"projeye_ekle",
          },
          {
            name:"attach_to_flow",
            color:"#6366f1",
            text:"akisa_gec",
          },
          {
            name:"update_custom_attribute",
            color:"#06b6d4",
            text:"ozel_niteligi_guncelle",
          },
          {
            name:"end_project_process",
            color:"#4dc247",
            text:"proje_surecini_tamamla",
          },
        ],
      },      
      {
        type:"date",
        field:"created_at",
        header:"eklenme_tarihi",
        hide_on_mobile:true,
      },
      ]
    }
  },
  mounted()
  {
    
    this.getData()
  },
  methods:{
  	async getData()
    {
        let items = await this.generalApiGetWithoutLoader("flow/conditions/"+this.$route.params.id)
        await console.log(items)
        for(let item of items)
        {
          let action = await JSON.parse(item.action)
          item.action = await action.name
          if(item.event=="supplier_added")
          {
            item.eventname = await this.$store.state.languages.lang_phrases.tedarikci_eklendiginde
          }
          if(item.event=="supplier_removed")
          {
            item.eventname = await this.$store.state.languages.lang_phrases.tedarikci_cikartildiginda
          }
          if(item.event=="flow_started")
          {
            item.eventname = await this.$store.state.languages.lang_phrases.basladiginda
          }
          if(item.event=="flow_concluded")
          {
            item.eventname = await this.$store.state.languages.lang_phrases.tamamlandiginda
          }

          if(item.event=="update_custom_attribute")
          {
            item.eventname = await this.$store.state.languages.lang_phrases.tamamlandiginda
          }

          if(item.event=="flow_info_updated")
          {
            item.eventname = await this.$store.state.languages.lang_phrases.akis_bilgisi_guncellendiginde
          }
          
        }
        await console.log(items)
        this.items = await items

        this.loading = await false
    },   
  }
};
</script>

<style lang="css" scoped>
</style>